// utils/schemaPresets.js
export const SCHEMA_PRESETS = [
  {
    id: 'facebook-scrape',
    label: 'Facebook Scrape',
    version: 1,
    platform: 'facebook',
    requiredCanon: ['Message', 'SenderScreenName', 'CreatedTime'],
    mappingSrcToCanon: {
      text: 'Message',
      'user/name': 'SenderScreenName',
      time: 'CreatedTime',
      url: 'Permalink',
      'user/id': 'SenderUserId',
      'user/profilePic': 'SenderProfileImgUrl',
      'user/profileUrl': 'SenderProfileUrl',
    },
  },
  // {
  //   id: 'datasetA',
  //   label: 'Schema 1 (x -Sprinkler)',
  //   version: 1,
  //   platform: 'x',
  //   requiredCanon: ['Message', 'SenderScreenName', 'CreatedTime'],
  //   mappingSrcToCanon: {
  //     // exact source headers → canon
  //     'Message': 'Message',
  //     'SenderScreenName': 'SenderScreenName',
  //     'CreatedTime': 'CreatedTime',
  //     'Message Type': 'Message Type'
  //   },
  //   // optional aliases for robust matching (used by autoDetectMapping below)
  //   aliases: {
  //     'text': ['message', 'msg', 'tweet_text'],
  //     'user_screen_name': ['screen_name', 'author', 'username'],
  //     'created_at': ['time', 'timestamp', 'date', 'created time']
  //   },
  //   valueMaps: {
  //     'Message Type': { Repost: 'X Repost', Reply: 'X Reply', Mention: 'X Mention', Update: 'X Update' }
  //   }
  //  },
  // {
  //   id: 'datasetB',
  //   label: 'Schema 2(x -testingSchema)',
  //   version: 2,
  //   platform: 'x',
  //   requiredCanon: ['Message', 'SenderScreenName', 'CreatedTime'],
  //   mappingSrcToCanon: {
  //     'Faultmasterfile_Message': 'Message',
  //     'Faultmasterfile_SenderScreenName': 'SenderScreenName',
  //     'Faultmasterfile_CreatedTime': 'CreatedTime',
  //     'Message Type': 'Message Type'
  //   },
  //   aliases: { 'Handle': ['User', 'Author Handle'] },
  //   valueMaps: { 'Message Type': { Repost: 'X Repost', Reply: 'X Reply' } }
  // },
  // {
  //   id: 'datasets',
  //   label: 'Schema 3 (x)',
  //   version: 2,
  //   platform: 'x',
  //   requiredCanon: ['Message', 'SenderScreenName', 'CreatedTime'],
  //   mappingSrcToCanon: {
  //     'Opening Text': 'Message',
  //     'Author Handle': 'SenderScreenName',
  //     'datetime': 'CreatedTime',
  //     'Reach': 'Message Type',
  //     'URL': 'Permalink'
  //   },
  //   aliases: { 'Handle': ['User', 'Author Handle'] },
  //   valueMaps: { 'Message Type': { Repost: 'X Repost', Reply: 'X Reply' } }
  // },
  // {
  //   id: 'datasets',
  //   label: 'Schema 1 (steam - sprinkler style)',
  //   version: 2,
  //   platform: 'steam',
  //   requiredCanon: ['Message', 'SenderScreenName', 'CreatedTime','OriginalPostId'],
  //   mappingSrcToCanon: {
  //     'Message': 'Message',
  //     'SenderScreenName': 'SenderScreenName',
  //     'CreatedTime': 'CreatedTime',
  //     'OriginalPostId': 'OriginalPostId',
  //   },
  //   aliases: { 'Handle': ['User', 'Author Handle'] },
  //   valueMaps: { 'Message Type': { Repost: 'X Repost', Reply: 'X Reply' } }
  // },
  // {
  //   id: 'datasets',
  //   label: 'Schema 1 (reddit - sprinkler style)',
  //   version: 2,
  //   platform: 'reddit',
  //   requiredCanon: ['Message', 'SenderScreenName', 'CreatedTime'],
  //   mappingSrcToCanon: {
  //     'Message': 'Message',
  //     'SenderScreenName': 'SenderScreenName',
  //     'CreatedTime': 'CreatedTime',
  //     'Title': 'Title',
  //   },
  //   aliases: { 'Handle': ['User', 'Author Handle'] },
  //   valueMaps: { 'Message Type': { 'Reddit Submission': 'X Repost', 'Reddit Reply': 'X Reply' } }
  // }
];

// helper: normalize header
export const norm = s => String(s ?? '').normalize('NFKC').replace(/\s+/g,' ').trim().toLowerCase();

// Try to build a mapping for a given preset against actual headers
export function autoDetectMapping(preset, actualHeaders) {
  const srcSet = new Set(actualHeaders.map(norm));
  const chosen = {};
  // invert mapping: canon → preferred source
  for (const [src, canon] of Object.entries(preset.mappingSrcToCanon)) {
    const candidates = [src, ...(preset.aliases?.[src] || [])];
    const hit = candidates.find(h => srcSet.has(norm(h)));
    if (hit) chosen[hit] = canon;
  }
  return chosen; // { actualSrcHeader → canon }
}

// quick score: how many canon fields are satisfiable
export function scorePreset(preset, actualHeaders) {
  const m = autoDetectMapping(preset, actualHeaders);
  const have = new Set(Object.values(m));
  const required = preset.requiredCanon || [];
  const covered = required.filter(c => have.has(c)).length;
  return { covered, total: required.length, mapping: m };
}
